<template>
	<v-toolbar app :height="heightToolbar" class="media-print">
	</v-toolbar>
</template>

<script>
function created() {
	window.addEventListener('resize', this.toolbarHeight);
	this.toolbarHeight();
}

function destroyed() {
	window.removeEventListener('resize', this.toolbarHeight);
}

function toolbarHeight() {
	const windowWidth = window.innerWidth;
	if (windowWidth >= 768) {
		this.heightToolbar = 40;
	} else {
		this.heightToolbar = 80;
	}
}

function data() {
	return {
		heightToolbar: 40,
	};
}

export default {
	name: 'app-subheader',
	created,
	data,
	destroyed,
	methods: {
		toolbarHeight,
	},
};
</script>

<style lang="scss" scoped>
.v-toolbar {
	background-color: map-get($colors, subheader);
	box-shadow: 0 1px 2px 0 rgba(0, 0, 0, .2);
	margin-top: 40px !important;
}

a {
	display: block;
	line-height: 1;
	text-decoration: none;

	@media (min-width: 768px) {
		line-height: 1.5;
	}
}

.v-subheader {
	&-name {
		color: map-get($colors, subheaderText);
		cursor: pointer;
		font-size: 13px;
		text-align: center;

		@media (min-width: 768px) {
			text-align: left;
			vertical-align: super;
		}
	}

	&-image-container {
		align-items: center;
		height: 30px;

		@media (min-width: 768px) {
			display: inline-flex;
		}
	}

	&-items {
		font-family: map-get($fonts, open-regular);
		padding-top: 2px;

		@media (min-width: 768px) {
			padding-right: 16px;
			padding-top: 0px;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/shared/app-subheader.vue